// data/InsureeSearchSchemas.js
export const insureeSearchFormSchema = [
  {
    id: "name",
    group: "Personal Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Name",
    value: "",
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "gender",
    group: "Personal Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Gender",
    value: "",
    isRequired: false,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "", label: "All" },
      { value: "M", label: "Male" },
      { value: "F", label: "Female" },
    ],
  },
  {
    id: "relationship",
    group: "Personal Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Relationship",
    value: "",
    isRequired: false,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "", label: "All" },
      { value: "Principal", label: "Principal" },
      { value: "Spouse", label: "Spouse" },
      { value: "Child", label: "Child" },
      { value: "Others", label: "Others" },
    ],
  },
  {
    id: "phone",
    group: "Contact Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Phone Number",
    value: "",
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "policyNumber",
    group: "Policy Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Policy Number",
    value: "",
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "cardNumber",
    group: "Policy Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Card Number",
    value: "",
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "policyTypeId",
    group: "Policy Information",
    label: "Policy Type",
    fieldType: "autocomplete",
    shownOnForm: true,
    width: "60%",
    isRequired: false,
    valueKey: "id",
    textValue: "label",
    onSearch: (query, deps) => {
      if (deps.onSearchPolicyTypes) {
        deps.onSearchPolicyTypes(query);
      }
    },
    options: (deps) => deps.policyTypes || [],
    loading: (deps) => deps.policyTypesLoading,
  },
];

export const insureeSearchRecord = {
  name: "",
  gender: "",
  relationship: "",
  phone: "",
  policyNumber: "",
  cardNumber: "",
  policyTypeId: null,
  externalErrors: {},
};
